import styled from 'particles/themes/styled'
import { theme } from 'theme'
const ResizeIcon = styled.div`
    width: 1px;
    height: 100px;
    background-color: ${theme.newColors.neutral50};
    margin-right: 16px;
`
export default ResizeIcon
